/** CoStar.Api.AptsNet.MobileServices.ViewModels.Criteria.GeographyFilterType */
export var GeographyFilterType;
(function (GeographyFilterType) {
    GeographyFilterType[GeographyFilterType["Unknown"] = 0] = "Unknown";
    GeographyFilterType[GeographyFilterType["PostalCode"] = 2] = "PostalCode";
    GeographyFilterType[GeographyFilterType["City"] = 3] = "City";
    GeographyFilterType[GeographyFilterType["Submarket"] = 5] = "Submarket";
    GeographyFilterType[GeographyFilterType["Street"] = 6] = "Street";
    GeographyFilterType[GeographyFilterType["ResearchMarket"] = 7] = "ResearchMarket";
    GeographyFilterType[GeographyFilterType["County"] = 10] = "County";
    GeographyFilterType[GeographyFilterType["Subdivision"] = 11] = "Subdivision";
    GeographyFilterType[GeographyFilterType["ShoppingCenter"] = 14] = "ShoppingCenter";
    GeographyFilterType[GeographyFilterType["Country"] = 15] = "Country";
    GeographyFilterType[GeographyFilterType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    GeographyFilterType[GeographyFilterType["Region"] = 17] = "Region";
    GeographyFilterType[GeographyFilterType["CBSA"] = 18] = "CBSA";
    GeographyFilterType[GeographyFilterType["CSA"] = 19] = "CSA";
    GeographyFilterType[GeographyFilterType["DMA"] = 20] = "DMA";
    GeographyFilterType[GeographyFilterType["Cluster"] = 21] = "Cluster";
    GeographyFilterType[GeographyFilterType["Airport"] = 22] = "Airport";
    GeographyFilterType[GeographyFilterType["HotelName"] = 23] = "HotelName";
    GeographyFilterType[GeographyFilterType["TransitStation"] = 24] = "TransitStation";
    GeographyFilterType[GeographyFilterType["Military"] = 25] = "Military";
    GeographyFilterType[GeographyFilterType["University"] = 26] = "University";
    GeographyFilterType[GeographyFilterType["SchoolWithAttendanceZone"] = 37] = "SchoolWithAttendanceZone";
    GeographyFilterType[GeographyFilterType["SchoolWithNoAttendanceZone"] = 38] = "SchoolWithNoAttendanceZone";
    GeographyFilterType[GeographyFilterType["SchoolDistrict"] = 39] = "SchoolDistrict";
    GeographyFilterType[GeographyFilterType["CityAggregate"] = 40] = "CityAggregate";
    GeographyFilterType[GeographyFilterType["CoStarMarket"] = 132] = "CoStarMarket";
})(GeographyFilterType || (GeographyFilterType = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.Criteria.StudentHousingTypes */
export var StudentHousingTypes;
(function (StudentHousingTypes) {
    StudentHousingTypes[StudentHousingTypes["None"] = 0] = "None";
    StudentHousingTypes[StudentHousingTypes["OnCampus"] = 1] = "OnCampus";
    StudentHousingTypes[StudentHousingTypes["OffCampus"] = 2] = "OffCampus";
})(StudentHousingTypes || (StudentHousingTypes = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.Criteria.StudentHousingPricingTypes */
export var StudentHousingPricingTypes;
(function (StudentHousingPricingTypes) {
    StudentHousingPricingTypes[StudentHousingPricingTypes["None"] = 0] = "None";
    StudentHousingPricingTypes[StudentHousingPricingTypes["Person"] = 1] = "Person";
    StudentHousingPricingTypes[StudentHousingPricingTypes["Room"] = 2] = "Room";
    StudentHousingPricingTypes[StudentHousingPricingTypes["Unit"] = 4] = "Unit";
})(StudentHousingPricingTypes || (StudentHousingPricingTypes = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.Criteria.StudentHousingAmenityTypes */
export var StudentHousingAmenityTypes;
(function (StudentHousingAmenityTypes) {
    StudentHousingAmenityTypes[StudentHousingAmenityTypes["None"] = 0] = "None";
    StudentHousingAmenityTypes[StudentHousingAmenityTypes["IndividualLockingBedrooms"] = 1] = "IndividualLockingBedrooms";
    StudentHousingAmenityTypes[StudentHousingAmenityTypes["OnlineResidentServices"] = 2] = "OnlineResidentServices";
    StudentHousingAmenityTypes[StudentHousingAmenityTypes["PrivateBathroom"] = 4] = "PrivateBathroom";
    StudentHousingAmenityTypes[StudentHousingAmenityTypes["RoommateMatching"] = 8] = "RoommateMatching";
    StudentHousingAmenityTypes[StudentHousingAmenityTypes["ShuttleToCampus"] = 16] = "ShuttleToCampus";
    StudentHousingAmenityTypes[StudentHousingAmenityTypes["StudyLounge"] = 32] = "StudyLounge";
    StudentHousingAmenityTypes[StudentHousingAmenityTypes["WalkToCampus"] = 64] = "WalkToCampus";
})(StudentHousingAmenityTypes || (StudentHousingAmenityTypes = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.Criteria.AmenityTypes */
export var AmenityTypes;
(function (AmenityTypes) {
    AmenityTypes[AmenityTypes["None"] = 0] = "None";
    AmenityTypes[AmenityTypes["SmokeFree"] = 1] = "SmokeFree";
    AmenityTypes[AmenityTypes["WasherDryer"] = 2] = "WasherDryer";
    AmenityTypes[AmenityTypes["Dishwasher"] = 4] = "Dishwasher";
    AmenityTypes[AmenityTypes["Heating"] = 8] = "Heating";
    AmenityTypes[AmenityTypes["AirConditioning"] = 16] = "AirConditioning";
    AmenityTypes[AmenityTypes["Balcony"] = 32] = "Balcony";
    AmenityTypes[AmenityTypes["Fireplace"] = 64] = "Fireplace";
    AmenityTypes[AmenityTypes["Furnished"] = 128] = "Furnished";
    AmenityTypes[AmenityTypes["Gym"] = 256] = "Gym";
    AmenityTypes[AmenityTypes["Pool"] = 512] = "Pool";
    AmenityTypes[AmenityTypes["TennisCourt"] = 1024] = "TennisCourt";
    AmenityTypes[AmenityTypes["RoofTerrace"] = 2048] = "RoofTerrace";
    AmenityTypes[AmenityTypes["BasketballCourt"] = 4096] = "BasketballCourt";
    AmenityTypes[AmenityTypes["Playground"] = 8192] = "Playground";
    /** @deprecated Please use PricingTools.RentSpecial instead. */
    AmenityTypes[AmenityTypes["RentSpecials"] = 16384] = "RentSpecials";
    AmenityTypes[AmenityTypes["GarageParking"] = 32768] = "GarageParking";
    AmenityTypes[AmenityTypes["WheelchairAccess"] = 65536] = "WheelchairAccess";
    AmenityTypes[AmenityTypes["Parking"] = 131072] = "Parking";
    AmenityTypes[AmenityTypes["HighSpeedInternet"] = 262144] = "HighSpeedInternet";
    AmenityTypes[AmenityTypes["Elevator"] = 524288] = "Elevator";
    AmenityTypes[AmenityTypes["WasherDryerHookup"] = 1048576] = "WasherDryerHookup";
    AmenityTypes[AmenityTypes["LaundryFacilities"] = 2097152] = "LaundryFacilities";
    AmenityTypes[AmenityTypes["Gated"] = 4194304] = "Gated";
    AmenityTypes[AmenityTypes["UtilitiesIncluded"] = 8388608] = "UtilitiesIncluded";
    AmenityTypes[AmenityTypes["Lofts"] = 16777216] = "Lofts";
    AmenityTypes[AmenityTypes["Basement"] = 33554432] = "Basement";
    AmenityTypes[AmenityTypes["BusinessCenter"] = 67108864] = "BusinessCenter";
    AmenityTypes[AmenityTypes["Clubhouse"] = 134217728] = "Clubhouse";
    AmenityTypes[AmenityTypes["Concierge"] = 268435456] = "Concierge";
    AmenityTypes[AmenityTypes["ControlledAccess"] = 536870912] = "ControlledAccess";
    AmenityTypes[AmenityTypes["Den"] = 1073741824] = "Den";
    AmenityTypes[AmenityTypes["Doorman"] = 2147483648] = "Doorman";
    AmenityTypes[AmenityTypes["HardwoodFloors"] = 4294967296] = "HardwoodFloors";
    AmenityTypes[AmenityTypes["Office"] = 8589934592] = "Office";
    AmenityTypes[AmenityTypes["Patio"] = 17179869184] = "Patio";
    AmenityTypes[AmenityTypes["WalkInClosets"] = 34359738368] = "WalkInClosets";
    AmenityTypes[AmenityTypes["Yard"] = 68719476736] = "Yard";
    AmenityTypes[AmenityTypes["CarChargingStation"] = 137438953472] = "CarChargingStation";
    /** @deprecated Use CarChargingStation instead */
    AmenityTypes[AmenityTypes["ElectricVehicleCharging"] = 137438953472] = "ElectricVehicleCharging";
})(AmenityTypes || (AmenityTypes = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.Criteria.BuildingRatings */
export var BuildingRatings;
(function (BuildingRatings) {
    BuildingRatings[BuildingRatings["None"] = 0] = "None";
    BuildingRatings[BuildingRatings["OneStar"] = 1] = "OneStar";
    BuildingRatings[BuildingRatings["TwoStar"] = 2] = "TwoStar";
    BuildingRatings[BuildingRatings["ThreeStar"] = 4] = "ThreeStar";
    BuildingRatings[BuildingRatings["FourStar"] = 8] = "FourStar";
    BuildingRatings[BuildingRatings["FiveStar"] = 16] = "FiveStar";
})(BuildingRatings || (BuildingRatings = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.Criteria.PetFriendlyPolicies */
export var PetFriendlyPolicies;
(function (PetFriendlyPolicies) {
    PetFriendlyPolicies[PetFriendlyPolicies["None"] = 0] = "None";
    PetFriendlyPolicies[PetFriendlyPolicies["Dog"] = 1] = "Dog";
    PetFriendlyPolicies[PetFriendlyPolicies["Cat"] = 2] = "Cat";
})(PetFriendlyPolicies || (PetFriendlyPolicies = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.Criteria.ListingTypes */
export var ListingTypes;
(function (ListingTypes) {
    ListingTypes[ListingTypes["None"] = 0] = "None";
    ListingTypes[ListingTypes["Apartment"] = 1] = "Apartment";
    ListingTypes[ListingTypes["House"] = 2] = "House";
    ListingTypes[ListingTypes["Condo"] = 4] = "Condo";
    ListingTypes[ListingTypes["Room"] = 8] = "Room";
    ListingTypes[ListingTypes["Townhouse"] = 16] = "Townhouse";
    ListingTypes[ListingTypes["Hospitality"] = 32] = "Hospitality";
})(ListingTypes || (ListingTypes = {}));
import { HousingSpecialties } from "../../../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.Criteria.HousingSpecialties */
export { HousingSpecialties };
import { PricingTools } from "../../../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.Criteria.PricingTools */
export { PricingTools };
/** CoStar.Api.AptsNet.MobileServices.ViewModels.Criteria.SearchOptions */
export var SearchOptions;
(function (SearchOptions) {
    SearchOptions[SearchOptions["None"] = 0] = "None";
    SearchOptions[SearchOptions["IncludeTier2"] = 1] = "IncludeTier2";
    SearchOptions[SearchOptions["IsNew"] = 2] = "IsNew";
    SearchOptions[SearchOptions["AllowSupplementalShortTermListings"] = 4] = "AllowSupplementalShortTermListings";
})(SearchOptions || (SearchOptions = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.Criteria.SortType */
export var SortType;
(function (SortType) {
    SortType[SortType["Default"] = 0] = "Default";
    SortType[SortType["LowestRent"] = 1] = "LowestRent";
    /** @deprecated This sort type is not yet supported. Do not use. */
    SortType[SortType["Newest"] = 2] = "Newest";
    SortType[SortType["HighestRent"] = 3] = "HighestRent";
    SortType[SortType["HasVideo"] = 4] = "HasVideo";
    SortType[SortType["Has3DTour"] = 5] = "Has3DTour";
    SortType[SortType["RecentlyUpdated"] = 6] = "RecentlyUpdated";
})(SortType || (SortType = {}));
import { HousingSubSpecialties } from "../../../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.Criteria.HousingSubSpecialties */
export { HousingSubSpecialties };
/** CoStar.Api.AptsNet.MobileServices.ViewModels.Criteria.Specialties */
export var Specialties;
(function (Specialties) {
    Specialties[Specialties["None"] = 0] = "None";
    Specialties[Specialties["Senior"] = 1] = "Senior";
    Specialties[Specialties["Military"] = 2] = "Military";
    Specialties[Specialties["Student"] = 4] = "Student";
    Specialties[Specialties["Corporate"] = 8] = "Corporate";
    Specialties[Specialties["ShortTerm"] = 16] = "ShortTerm";
    Specialties[Specialties["IncomeRestricted"] = 32] = "IncomeRestricted";
})(Specialties || (Specialties = {}));
